import { DISCUSSION_LIMITS } from 'lib/community/discussions-writer'
import styles from './Writer.module.css'

interface HeadingBlockProps {
  text: string
  onChange: (value: string) => void
}

const HeadingBlock: React.VFC<HeadingBlockProps> = ({ text, onChange }) => (
  <input
    className={styles.heading}
    type="text"
    value={text}
    maxLength={DISCUSSION_LIMITS.headingChars}
    placeholder="Heading"
    aria-label="Heading"
    onChange={e => onChange(e.target.value)}
  />
)

export default HeadingBlock
